var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"responsibility-directory-form-menu"},[_c('div',{staticClass:"responsibility-directory-form-menu__inner"},[_c('HorizontalMenu',{attrs:{"items":_vm.items,"value":_vm.value,"size":"small","bottomLine":false,"hideLines":true},on:{"onChange":_vm.handleOnChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }